export default {
  "ede5ad04f7": "是否手抄",
  "f93d7233ea": "已埋点：",
  "7b317dc923": "未埋点：",
  "ae336cd047": "收藏",
  "934ebd87e6": "已收藏",
  "5442a970ed": "查看简评",
  "f93572dc20": "简评",
  "0350555272": "已添加至“我的收藏”",
  "5aa512fef5": "去看看",
  "21efd88b67": "暂无数据",
  "81d76b746b": "网络连接失败",
  "6ab5f11fbd": "图说数据",
  "62a4a22dc0": "请登录后在收藏!",
  "097e5cfa00": "收藏失败,请重新登录后重试!",
  "866b795eae": "加载失败",
  "26b5bd4947": "加载中...",
  "2b496a8eac": "已经到底了",
  "9a79b39a1a": "暂无收藏内容",
  "975ff67ee1": "我的收藏",
  "cd11be8c92": "请输入关键词",
  "625fb26b4b": "取消",
  "3ad3cfa11b": "清除历史记录",
  "da324a561e": "确认删除全部历史记录？",
  "2f4aaddde3": "删除",
  "d12f75264c": "暂无搜索内容",
  "1c6e68c78d": "转载需注明“同花顺iFinD”，数据来源见图片标注，内容涉及的个股及行业不代表平台观点，不构成投资建议。",
  "35f414b9c2": "为你推荐",
  "66ef92bbe5": "请登录后再收藏",
  "f62827f0c4": "收藏成功！",
  "cb0f88686e": "取消收藏成功！",
  "b32b0111c1": "收藏失败",
  "e8b9e5dda8": "请登录后再收藏",
  "4233a27bd6": "暂无收藏",
  "a715bb174b": "客户端调用",
  "bfe4bd3c5e": "客户端调用失败",
  "6d596f3e1b": "请在客户端内调用",
  "8818d4830d": "首页",
  "0b6d2219c6": "收藏失败!",
  "a8b0c20416": "全部",
  "111": "下载失败,请稍后再试!",
  "112": "图片已下架!",
  "113": "网络拥挤，请稍后再试",
  "114": "AI绘图",
  "115": "热榜",
  "0cd025fa": "你想看什么",
  "12822ccb": "我们来出图"
}
